import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';
import moment from 'moment';

const state = {
    id: 0,
    fechaContable: moment(new Date()).format('YYYY-MM-DD'),
    clienteId: 0,
    cliente: {},
    clienteNombre: null,
    /*total: 0,*/
    monedaId: 0,
    monedaNombre: null,
    cotizacion: 0,
    // cotizacionEnabled: Boolean(false),
    observaciones: '',

    cuentaCorriente: [],
    cuentaCorrienteDisplay: [],
    totalCuentaCorriente: 0,
    totalSeleccionado: 0,
    cantidadSeleccionados: 0,

    totalCuentaCorrientePesos: 0,
    totalSeleccionadoPesos: 0,
    totalCuentaCorrienteDolares: 0,
    totalSeleccionadoDolares: 0,

    /* Documentos */
    pesos: 0,
    // importeTransferenciasClientes: 0,
    importeTransferenciasClientesPesos: 0,
    importeTransferenciasClientesDolares: 0,
    transferenciasClientes: [],
    importeChequesTercerosPesos: 0,
    importeChequesTercerosDolares: 0,
    chequesTerceros: [],
    importeRetencionesClientesPesos: 0,
    retencionesClientes: [],
    // importeTransferenciasDevolucion: 0,
    importeTransferenciasDevolucionPesos: 0,
    importeTransferenciasDevolucionDolares: 0,
    transferenciasDevolucion: [],

    /* Caja */
    cajaRegistroId: 0,
    cajaRegistro: null,
    cajaRegistroNombre: null,

    /* Cuenta corriente seleccionada para dejar el saldo */
    cuentaCorrienteSaldoId: 0,

    cobroDatos: [],
    cobroComprobantes: [],
    cobroDocumentos: [],
    cobroChequesTerceros: [],
    cobroTransferencias: [],
    cobroRetencionesClientes: [],
    
    cobroDatosRpt: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_COBRO' (state) {
        state.id = 0;
        state.fechaContable = moment(new Date()).format('YYYY-MM-DD'),
        state.clienteId= 0;
        state.cliente= null;
        state.clienteNombre= null;
        state.monedaId= 101;
        state.monedaNombre = 'PESOS';
        state.cotizacion = 1;
        state.observaciones = '';

        state.cuentaCorriente= [];
        state.cuentaCorrienteDisplay = [];
        state.totalCuentaCorriente = 0;
        state.totalSeleccionado = 0;
        state.cantidadSeleccionados = 0;

        state.cajaRegistro = null;
        state.cajaRegistroId = 0;
        state.cajaRegistroNombre = null;

        calcularTotalesCuentaCorriente(state);

        inicializarDocumentos(state);

        state.cuentaCorrienteSaldoId = 0;
    },
    'SET_CLIENTE'(state, cliente) {
        state.cliente = cliente;
        state.clienteId = cliente ? cliente.id : 0;
        state.clienteNombre = cliente ? cliente.nombre.trim() : null;
    },
    'SET_CUENTA_CORRIENTE'(state, cuentaCorriente) {
        state.cuentaCorriente = [];
        state.cuentaCorrienteDisplay = [];

        state.cuentaCorriente = cuentaCorriente.map(cuentaCorriente => ({
            ...cuentaCorriente,
            selected: Boolean(false),
            seleccionDisabled: Boolean(false),
            _rowVariant: ''
        }))

        state.cuentaCorrienteDisplay = [...state.cuentaCorriente];

        state.paginaActual = 1;
        state.totalRegistros = state.cuentaCorrienteDisplay.length;

        calcularTotalesCuentaCorriente(state);

        state.monedaId= 0;
        state.monedaNombre = null;
        state.cotizacion = 1;
    },
    'SELECCIONAR_CUENTA_CORRIENTE' (state, cuentaCorrienteId) {
        /* Buscamos la info del item seleccionado para filtrar los comprobantes */
        let item = state.cuentaCorriente
            .find(ccp => ccp.id == cuentaCorrienteId);

        if (item) {
            if (item.selected) {
                /* Seleccionamos los parametros de la orden de pago */
                if (state.monedaId == 0) {
                    state.monedaId= item.monedaId;
                    state.monedaNombre = item.moneda;
                    state.cotizacion = 1;

                    // if (state.monedaId == 101) {
                    //     state.cotizacionEnabled = Boolean(false);
                    // } else {
                    //     state.cotizacionEnabled = Boolean(true);
                    // }
                }
            }
        }

        calcularTotalesCuentaCorriente(state);

        if (!state.cantidadSeleccionados) {
            state.monedaId= 0;
            state.monedaNombre = null;
            state.cotizacion = 0;
            // state.cotizacionEnabled = Boolean(false);
        } 

        state.cuentaCorriente.forEach(cuentaCorriente => {
            let disabled = false;

            if (cuentaCorriente.monedaId != 0) {
                if (state.monedaId != 0 & cuentaCorriente.monedaId != state.monedaId) {
                    disabled = true;
                }
            }

            if (disabled) {
                cuentaCorriente.seleccionDisabled = Boolean(true),
                cuentaCorriente._rowVariant = 'danger';
            } else {
                cuentaCorriente.seleccionDisabled = Boolean(false),
                cuentaCorriente._rowVariant = '';
            }
        });

        state.cuentaCorrienteDisplay = [...state.cuentaCorriente];
    },
    'CALCULAR_TOTAL_SELECCIONADO' (state) {
        calcularTotalesCuentaCorriente(state);
    },
    'SET_CAJA_REGISTRO' (state, cajaRegistro) {
        state.cajaRegistro = cajaRegistro;
        state.cajaRegistroId = 0;
        state.cajaRegistroNombre = null;
        if (cajaRegistro) {
            if (cajaRegistro.id) {
                state.cajaRegistroId = cajaRegistro.id;
            }
            if (cajaRegistro.nombre) {
                state.cajaRegistroNombre = cajaRegistro.nombre.toUpperCase().trim();
            }
        }
    },

    'SET_TRANSFERENCIA_CLIENTES' (state, transferenciaCliente) {
        state.transferenciasClientes.push(transferenciaCliente);

        if (state.transferenciasClientes.lenght != 0) {
            // state.importeTransferenciasClientes = state.transferenciasClientes
            //     .reduce((a, b) => a + b.importe, 0);

            state.importeTransferenciasClientesPesos = state.transferenciasClientes
                .filter(t => t.monedaId == 101)
                .reduce((a, b) => a + b.importe, 0);

            state.importeTransferenciasClientesDolares = state.transferenciasClientes
                .filter(t => t.monedaId == 102)
                .reduce((a, b) => a + b.importe, 0);
        } else {
            // state.importeTransferenciasClientes = 0;
            state.importeTransferenciasClientesPesos = 0;
            state.importeTransferenciasClientesDolares = 0;
        }
    },
    'DELETE_TRANSFERENCIA_CLIENTES' (state, transferenciaClientes) {
        let itemKey = state.transferenciasClientes
            .findIndex(transferencia => transferenciaClientes == transferencia);

        if (itemKey != -1) {
            state.transferenciasClientes.splice(itemKey, 1);
        }

        if (state.transferenciasClientes.lenght != 0) {
            // state.importeTransferenciasClientes = state.transferenciasClientes
            //     .reduce((a, b) => a + b.importe, 0);

            state.importeTransferenciasClientesPesos = state.transferenciasClientes
                .filter(t => t.monedaId == 101)
                .reduce((a, b) => a + b.importe, 0);

            state.importeTransferenciasClientesDolares = state.transferenciasClientes
                .filter(t => t.monedaId == 102)
                .reduce((a, b) => a + b.importe, 0);
        } else {
            // state.importeTransferenciasClientes = 0;
            state.importeTransferenciasClientesPesos = 0;
            state.importeTransferenciasClientesDolares = 0;
        }
    },

    'SET_CHEQUE_TERCEROS' (state, chequeTerceros) {
        state.chequesTerceros.push(chequeTerceros);

        if (state.chequesTerceros.lenght != 0) {
            state.importeChequesTercerosPesos = state.chequesTerceros
                // .filter(t => t.monedaId == 101)
                .reduce((a, b) => a + b.importe, 0);
        } else {
            state.importeChequesTercerosPesos = 0;
        }
    },
    'DELETE_CHEQUE_TERCEROS' (state, chequeTerceros) {
        let itemKey = state.chequesTerceros
            .findIndex(cheque => chequeTerceros == cheque);

        if (itemKey != -1) {
            state.chequesTerceros.splice(itemKey, 1);
        }

        if (state.chequesTerceros.lenght != 0) {
            state.importeChequesTercerosPesos = state.chequesTerceros
                // .filter(t => t.monedaId == 101)
                .reduce((a, b) => a + b.importe, 0);
        } else {
            state.importeChequesTercerosPesos = 0;
        }
    },

    'SET_RETENCION_CLIENTE' (state, retencionCliente) {
        state.retencionesClientes.push(retencionCliente);

        if (state.retencionesClientes.lenght != 0) {
            state.importeRetencionesClientesPesos = state.retencionesClientes
                .reduce((a, b) => a + b.importe, 0);
        } else {
            state.importeRetencionesClientesPesos = 0;
        }
    },
    'DELETE_RETENCION_CLIENTE' (state, retencionCliente) {
        let itemKey = state.retencionesClientes
            .findIndex(retencion => retencionCliente == retencion);

        if (itemKey != -1) {
            state.retencionesClientes.splice(itemKey, 1);
        }

        if (state.retencionesClientes.lenght != 0) {
            state.importeRetencionesClientesPesos = state.retencionesClientes
                .reduce((a, b) => a + b.importe, 0);
        } else {
            state.importeRetencionesClientesPesos = 0;
        }
    },

    'SET_TRANSFERENCIA_DEVOLUCION' (state, transferenciaDevolucion) {
        state.transferenciasDevolucion.push(transferenciaDevolucion);

        if (state.transferenciasDevolucion.lenght != 0) {
            // state.importeTransferenciasDevolucion = state.transferenciasDevolucion
            //     .reduce((a, b) => a + b.importe, 0);

            state.importeTransferenciasDevolucionPesos = state.transferenciasDevolucion
                .filter(t => t.monedaId == 101)
                .reduce((a, b) => a + b.importe, 0);

            state.importeTransferenciasDevolucionDolares = state.transferenciasDevolucion
                .filter(t => t.monedaId == 102)
                .reduce((a, b) => a + b.importe, 0);
        } else {
            // state.importeTransferenciasDevolucion = 0;
            state.importeTransferenciasDevolucionPesos = 0;
            state.importeTransferenciasDevolucionDolares = 0;
        }
    },
    'DELETE_TRANSFERENCIA_DEVOLUCION' (state, transferenciaDevolucion) {
        let itemKey = state.transferenciasDevolucion
            .findIndex(transferencia => transferenciaDevolucion == transferencia);

        if (itemKey != -1) {
            state.transferenciasDevolucion.splice(itemKey, 1);
        }

        if (state.transferenciasDevolucion.lenght != 0) {
            // state.importeTransferenciasDevolucion = state.transferenciasDevolucion
            //     .reduce((a, b) => a + b.importe, 0);

            state.importeTransferenciasDevolucionPesos = state.transferenciasDevolucion
                .filter(t => t.monedaId == 101)
                .reduce((a, b) => a + b.importe, 0);

            state.importeTransferenciasDevolucionDolares = state.transferenciasDevolucion
                .filter(t => t.monedaId == 102)
                .reduce((a, b) => a + b.importe, 0);
        } else {
            // state.importeTransferenciasDevolucion = 0;
            state.importeTransferenciasDevolucionPesos = 0;
            state.importeTransferenciasDevolucionDolares = 0;
        }
    },

    'SET_CUENTA_CORRIENTE_SALDO' (state) {
        state.cuentaCorrienteSaldoId = 0;

        let saldo = getSaldo(state);

        if (saldo > 0) {
            /* Saldo en uno de los comprobantes incluidos */
            let cuentaCorriente = state.cuentaCorriente
                .filter(cuentaCorriente => cuentaCorriente.selected)
                .reduce(function(prev, current) {
                    return (prev.saldo > current.saldo) ? prev : current
                })            

            if (cuentaCorriente) {
                if ((cuentaCorriente.saldo * state.cotizacion) >= saldo) {
                    /* Verificamos que el saldo del comprobante sea mayor al saldo del recibo */
                    state.cuentaCorrienteSaldoId = cuentaCorriente.id;
                }
            }
        }
    },
    'VALIDAR_MONEDA' (state) {
        /* Si no hay comprobantes seleccionados, selecciono pesos como moneda */
        if (state.totalSeleccionadoPesos == 0 & state.totalSeleccionadoDolares == 0) {
            state.monedaId= 101;
            state.monedaNombre = 'PESOS';
            state.cotizacion = 1;
        }
    },

    'INICIALIZAR_DATOS' (state) {
        state.cobroDatos = [];
        state.cobroChequesTerceros = [];
        state.cobroTransferencias = [];
        state.cobroRetencionesClientes = [];
        state.cobroDatosRpt = [];
    },
    'SET_COBRO_DATOS' (state, params) {
        state.cobroDatos = params.cobroDatos;
        state.cobroComprobantes = params.cobroComprobantes;
        state.cobroDocumentos = params.cobroDocumentos;
        state.cobroChequesTerceros = params.cobroChequesTerceros;
        state.cobroTransferencias = params.cobroTransferencias;
        state.cobroRetencionesClientes = params.cobroRetencionesClientes;
        
        state.cobroDatosRpt = params.cobroDatosRpt;
        
        /* Sumarizamos los documentos en el cobro */
        if (state.cobroDatosRpt) {
            if (state.cobroDatosRpt.clienteDocumentoTipoId == 2) {
                /* CUIT */
                state.cobroDatosRpt.clienteDocumentoNumero = helpers.methods.formattedCuit(state.cobroDatosRpt.clienteDocumentoNumero);
            }
    
            let importeDocumentos = 0;
            let importeChequesTerceros = 0;
            let importeTransferencias = 0;
            let importeRetencionesClientes = 0;

            if (state.cobroDatosRpt.documentos.lenght != 0) {
                importeDocumentos = state.cobroDatosRpt.documentos
                    .reduce((a, b) => a + b.importe, 0);
            }
            if (state.cobroDatosRpt.chequesTerceros.lenght != 0) {
                importeChequesTerceros = state.cobroDatosRpt.chequesTerceros
                    .reduce((a, b) => a + b.importe, 0);
            }
            if (state.cobroDatosRpt.transferencias.lenght != 0) {
                importeTransferencias = state.cobroDatosRpt.transferencias
                    .reduce((a, b) => a + b.importe, 0);
            }
            if (state.cobroDatosRpt.retencionesClientes.lenght != 0) {
                importeRetencionesClientes = state.cobroDatosRpt.retencionesClientes
                    .reduce((a, b) => a + b.importe, 0);
            }
            state.cobroDatosRpt.importeDocumentos = importeDocumentos;
            state.cobroDatosRpt.importeChequesTerceros = importeChequesTerceros;
            state.cobroDatosRpt.importeTransferencias = importeTransferencias;
            state.cobroDatosRpt.importeRetencionesClientes = importeRetencionesClientes;
        }
    },
};

function inicializarDocumentos(state) {
    state.pesos = 0;
    // state.importeTransferenciasClientes = 0;
    state.importeTransferenciasClientesPesos = 0;
    state.importeTransferenciasClientesDolares = 0;
    state.transferenciasClientes = [];
    state.importeChequesTercerosPesos = 0;
    state.importeChequesTercerosDolares = 0;
    state.chequesTerceros = [];
    state.importeRetencionesClientesPesos = 0;
    state.retencionesClientes = [];
    // state.importeTransferenciasDevolucion = 0;
    state.importeTransferenciasDevolucionPesos = 0;
    state.importeTransferenciasDevolucionDolares = 0;
    state.transferenciasDevolucion = [];
}

function getTotalDocumentos(state) {
    if (state.monedaId == 101) {
        return parseFloat(state.pesos)
            + parseFloat(state.importeTransferenciasClientesPesos)
            + parseFloat(state.importeTransferenciasClientesDolares) * parseFloat(state.cotizacion)
            + parseFloat(state.importeChequesTercerosPesos)
            + parseFloat(state.importeChequesTercerosDolares) * parseFloat(state.cotizacion)
            + parseFloat(state.importeRetencionesClientesPesos)
            - parseFloat(state.importeTransferenciasDevolucionPesos)
            - parseFloat(state.importeTransferenciasDevolucionDolares) * parseFloat(state.cotizacion);
    }

    if (state.monedaId == 102) {
        return parseFloat(state.pesos) / parseFloat(state.cotizacion)
            + parseFloat(state.importeTransferenciasClientesPesos) / parseFloat(state.cotizacion)
            + parseFloat(state.importeTransferenciasClientesDolares)
            + parseFloat(state.importeChequesTercerosPesos) / parseFloat(state.cotizacion)
            + parseFloat(state.importeChequesTercerosDolares)
            + parseFloat(state.importeRetencionesClientesPesos)
            - parseFloat(state.importeTransferenciasDevolucionPesos) / parseFloat(state.cotizacion)
            - parseFloat(state.importeTransferenciasDevolucionDolares);
    }

    return parseFloat(state.pesos)
        + parseFloat(state.importeTransferenciasClientesPesos)
        + parseFloat(state.importeTransferenciasClientesDolares)
        + parseFloat(state.importeChequesTercerosPesos)
        + parseFloat(state.importeChequesTercerosDolares)
        + parseFloat(state.importeRetencionesClientesPesos)
        - parseFloat(state.importeTransferenciasDevolucionPesos)
        - parseFloat(state.importeTransferenciasDevolucionDolares);
}

function getSaldo (state) {
    return parseFloat(state.totalSeleccionado) - getTotalDocumentos(state);
}

function calcularTotalesCuentaCorriente (state) {
    state.totalSeleccionado = 0;
    state.cantidadSeleccionados = 0;

    state.totalCuentaCorrientePesos = 0;
    state.totalSeleccionadoPesos = 0;
    state.totalCuentaCorrienteDolares = 0;
    state.totalSeleccionadoDolares = 0;

    state.totalSeleccionado = state.cuentaCorriente
        .reduce((a, b) => a + ( b.selected ? b.saldo : 0 ), 0);

    state.cantidadSeleccionados = state.cuentaCorriente
        .reduce((a, b) => a + ( b.selected ? 1 : 0 ), 0);

    state.totalCuentaCorrientePesos = state.cuentaCorriente
        .reduce((a, b) => a + (b.monedaId == 101 ? b.saldo : 0), 0);
    state.totalSeleccionadoPesos = state.cuentaCorriente
        .reduce((a, b) => a + (b.monedaId == 101 & b.selected ? b.saldo : 0), 0);

    state.totalCuentaCorrienteDolares = state.cuentaCorriente
        .reduce((a, b) => a + (b.monedaId == 102 ? b.saldo : 0), 0);
    state.totalSeleccionadoDolares = state.cuentaCorriente
        .reduce((a, b) => a + (b.monedaId == 102 & b.selected ? b.saldo : 0), 0);
}

const getters = {
    getField,

    totalDocumentos(state) {
        return getTotalDocumentos(state);
    },
    saldo(state) {
        return getSaldo(state);
    },

    cobroDatosRpt(state) {
        return state.cobroDatosRpt;
    },
};

const actions = {
    inicializar ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_COBRO');
            
             /* Recuperamos la caja central */
            apiAxios.get('cajas/central')
                .then((res) => {
                    commit("SET_CAJA_REGISTRO", res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            
        })            
    },
    setCuentaCorrienteSaldo ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('SET_CUENTA_CORRIENTE_SALDO');
            resolve();
        })            
    },
    save ( { state, commit } ) {
        return new Promise((resolve, reject) => {
            let save = true;
            let errorMessage = '';

            let totalDocumentos = getTotalDocumentos(state);

            if (totalDocumentos == 0 && parseFloat(state.cantidadSeleccionados) == 0) {
                save = false;
                errorMessage = "El total de la orden de cobro no puede ser igual a cero."
            }

            /* Validamos si se pudo dejar el saldo en un comprobante */
            commit('SET_CUENTA_CORRIENTE_SALDO');

            if (state.totalSeleccionado > totalDocumentos) {
                /* Verificamos si se seleccionó un comprobante para el saldo del pago */
                if (state.cuentaCorrienteSaldoId == 0) {
                    save = false;
                    errorMessage = "No se pudo seleccionar un comprobante con saldo suficiente para asignar el saldo de la orden de cobro."
                }
            }
        
            if (save) {
                let selected = [];
                for(let key in state.cuentaCorrienteDisplay) {
                    let cuentaCorriente = state.cuentaCorrienteDisplay[key];
                    if ((/true/i).test(cuentaCorriente.selected)) {
                        let item = {
                            cuentaCorrienteClienteId: parseInt(cuentaCorriente.id),
                            rowVersion: cuentaCorriente.rowVersion,
                        }
                        selected.push(item);
                    }
                }

                let cobro= {
                    fechaContable: moment(state.fechaContable).format('YYYY-MM-DD'),
                    clienteId: parseInt(state.clienteId),
                    monedaId: parseInt(state.monedaId),
                    cotizacion: parseFloat(state.cotizacion),
                    observaciones: state.observaciones.trim(),
                    cobrosCuentaCorriente: selected,

                    pesos: parseFloat(state.pesos),
                    chequesTerceros: state.chequesTerceros,
                    retencionesClientes: state.retencionesClientes,
                    transferenciasClientes: state.transferenciasClientes,
                    transferenciasDevolucion: state.transferenciasDevolucion,
                    cajaRegistroId: state.cajaRegistroId,
                    cuentaCorrienteClienteId: state.cuentaCorrienteSaldoId
                };

                let url = 'cobros';

                apiAxios.post(url, cobro)
                    .then(() => resolve())
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                reject(errorMessage);
            }
        })
    },
    setCliente: ({ commit }, cliente) => {
        return new Promise((resolve, reject) => {
            commit('SET_CLIENTE', cliente);

            if (cliente != null) {
                if (cliente.id != 0) {
                    apiAxios.get(`cuentacorrienteclientes/${cliente.id}/deuda`)
                        .then(res => {
                            commit('SET_CUENTA_CORRIENTE', res.data);
                            resolve();
                        })
                        .catch(error => reject(helpers.methods.getErrorMessage(error)));
                } else {
                    resolve();        
                }
            } else {
                resolve();
            }
        })
    },
    setCajaRegistro ( { commit }, cajaRegistro ) {
        commit('SET_CAJA_REGISTRO', cajaRegistro);
    },
    setTransferenciaClientes ( { commit }, transferenciaClientes ) {
        commit('SET_TRANSFERENCIA_CLIENTES', transferenciaClientes);
    },
    deleteTransferenciaClientes ( { commit }, transferenciaClientes ) {
        commit('DELETE_TRANSFERENCIA_CLIENTES', transferenciaClientes);
    },
    setChequeTerceros ( { commit }, chequeTerceros ) {
        commit('SET_CHEQUE_TERCEROS', chequeTerceros);
    },
    deleteChequeTerceros ( { commit }, chequeTerceros ) {
        commit('DELETE_CHEQUE_TERCEROS', chequeTerceros);
    },
    setRetencionCliente ( { commit }, retencionCliente ) {
        commit('SET_RETENCION_CLIENTE', retencionCliente);
    },
    deleteRetencionCliente ( { commit }, retencionCliente ) {
        commit('DELETE_RETENCION_CLIENTE', retencionCliente);
    },
    setTransferenciaDevolucion ( { commit }, transferenciaDevolucion ) {
        commit('SET_TRANSFERENCIA_DEVOLUCION', transferenciaDevolucion);
    },
    deleteTransferenciaDevolucion ( { commit }, transferenciaDevolucion ) {
        commit('DELETE_TRANSFERENCIA_DEVOLUCION', transferenciaDevolucion);
    },
    calcularTotalSeleccionado ( { commit } ) {
        commit('CALCULAR_TOTAL_SELECCIONADO');
    },
    seleccionarCuentaCorriente ( { commit }, cuentaCorrienteId ) {
        return new Promise((resolve, reject) => {
            commit('SELECCIONAR_CUENTA_CORRIENTE', cuentaCorrienteId);
            resolve();
        })
    },
    validarMoneda ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('VALIDAR_MONEDA');
            resolve();
        })
    },

    getDatos ( { commit }, cobroId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');

            if (cobroId) {
                apiAxios.get('cobros/' + cobroId ) 
                    .then(res => {
                        const total = `${res.data.moneda.trim()} ${helpers.methods.formattedImporte(res.data.total)}`;
                        const saldo = `${res.data.moneda.trim()} ${helpers.methods.formattedImporte(res.data.saldo)}`;

                        let cobroDatos = [
                            { 'nombre': 'id', 'campo': 'Nro. Orden', 'valor': res.data.id, 'formato': '' },
                            { 'nombre': 'fechaRegistro', 'campo': 'Fecha', 'valor': res.data.fechaRegistro, 'formato': 'fecha' },
                            { 'nombre': 'fechaContable', 'campo': 'Fecha Contable', 'valor': res.data.fechaContable, 'formato': 'fecha' },
                            { 'nombre': 'cliente', 'campo': 'Cliente', 'valor': res.data.cliente, 'formato': '' },
                            { 'nombre': 'total', 'campo': 'Total', 'valor': total, 'formato': '' },
                            { 'nombre': 'saldo', 'campo': 'Saldo', 'valor': saldo, 'formato': '' }
                        ];

                        if (res.data.monedaId != 101) {
                            cobroDatos.push(
                                { 'nombre': 'cotizacion', 'campo': 'Cotización', 'valor': res.data.cotizacion, 'formato': 'moneda' },
                            );
                        } else if (res.data.cotizacion != 1) {
                            cobroDatos.push(
                                { 'nombre': 'cotizacion', 'campo': 'TC USD', 'valor': res.data.cotizacion, 'formato': 'moneda' },
                            );
                        }

                        cobroDatos.push(
                            { 'nombre': 'observaciones', 'campo': 'Observaciones', 'valor': res.data.observaciones.trim(), 'formato': '' },
                        );

                        let params = {
                            cobroDatos,
                            cobroComprobantes: res.data.comprobantes,
                            cobroDocumentos: res.data.documentos,
                            cobroChequesTerceros: res.data.chequesTerceros,
                            cobroTransferencias: res.data.transferencias,
                            cobroRetencionesClientes: res.data.retencionesClientes,
                            cobroDatosRpt: res.data
                        }
                                      
                        commit('SET_COBRO_DATOS', params);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}